
import { BasicLayoutManager } from "@goodgamestudios/core";
import { BasicUserEvent } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { AvatarCreationEvent } from "../../../event/AvatarCreationEvent";
import { Poker2UserEvent } from "../../../event/Poker2UserEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2LayoutManager } from "../../../view/Poker2LayoutManager";
import { Poker2Command } from "../Poker2Command";

import { ExternalInterface } from "@goodgamestudios/createjs-utilities";

export class LRECommand extends Poker2Command {
    protected get cmdId(): string {
        return "lre";
    }

    public executeCommand(error: number, params: any[]): boolean {
        var paramsObj: any;

        switch (error) {
            case 0:
                this.env.isFirstVisit = true;
                this.controller.dispatchEvent(new BasicUserEvent(BasicUserEvent.REGISTERED, [true]));
                if (this.env.campainVars.isValid() && ExternalInterface.available) {
                    ExternalInterface.call("onRegisterComplete");
                }
                Poker2Model.localData.saveCookieExists();

                // needed for AB-test conversion tracking
                Poker2Model.userData.registeredInThisSession = true;
                break;
            case 26:
                this.env.isFirstVisit = true;
                Poker2LayoutManager.getInstance().state = BasicLayoutManager.STATE_AVATAR_CREATION;
                this.controller.dispatchEvent(new BasicUserEvent(BasicUserEvent.REGISTERED, [true]));
                break;
            case 22:
                if (params[1]) {
                    paramsObj = JSON.parse(params[1]);

                    if (paramsObj.NS)
                        this.controller.dispatchEvent(new AvatarCreationEvent("avatarnamesuggestions", [paramsObj]));
                }
                break;
            default:
                this.controller.dispatchEvent(new Poker2UserEvent("registerFailed", [error]));
                break;
        }
        return (error == 0);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
